<template>
  <div id="app">
    <el-container>
      <el-header class="top-banner" height="auto">
        <bannerComponent></bannerComponent>
      </el-header>
      <el-header class="navigation_bar">
        <navigationBarComponent></navigationBarComponent>
      </el-header>
      <el-main>
        <el-row>
          <el-col :span="20" :offset="2">
            <router-view v-if="isRouterAlive" />
            <el-col
              :xl="{ span: 6 }"
              :lg="{ span: 6 }"
              :md="{ span: 6 }"
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              v-if="needShow"
            >
              <!--右边登录部分-->

              <loginComponent></loginComponent>
            </el-col>
          </el-col>
        </el-row>
      </el-main>
      <el-footer class="footer" style="height: 160px">
        <footerComponent></footerComponent>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import navigationBarComponent from "@/components/navigationBarComponent";
import bannerComponent from "@/components/bannerComponent";
import footerComponent from "@/components/footerComponent";
import loginComponent from "@/components/loginComponent";
export default {
  name: "App",
  components: {
    navigationBarComponent,
    bannerComponent,
    footerComponent,
    loginComponent,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isMobile: false,
      screenwidth: document.body.clientwidth,
      userInfo: null,
      isRouterAlive: true,
      needShow: true,
    };
  },
  computed: {},
  beforeUpdate() {
    this.userInfo = this.$cookie.getCookie("userInfo");
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  mounted() {
    const needShowRoute = ["index", "manuscriptsList"];
    
    this.needShow = needShowRoute.indexOf(this.$route.name) != -1;
  },
  updated() {
    
    
    this.needShow = this.$route.meta.loginNeedShow
  },
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-image: url(../static/materials/dalishi.png);
  padding: 0 !important;
  margin: 0 !important;
}

.top-banner {
  background-image: linear-gradient(to right, #002412, #005152, #006a71);
  color: #d3dce6;
  margin: 0%;
  padding: 0%;
}

.navigation_bar {
  margin: 0%;
  padding: 0%;
  color: aliceblue;
  background-image: linear-gradient(#006a71, #005152, #002412);
}

.main {
  background-color: white;
  color: #333;
  padding: 0 !important;
  margin: 0 !important;
}
.footer {
  background-color: #004c48;
  color: white;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  padding-top: 18px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue